import { graphql } from '~publish/graphql'

import { SavedViewFields } from './SavedViewFields'

export const SavedViewsQuery = graphql(
  /* GraphQL */ `
    query SavedViews($input: SavedViewsInput!) {
      savedViews(input: $input) {
        savedViews {
          ...SavedViewFields
        }
      }
    }
  `,
  [SavedViewFields],
)
